import { produce } from 'immer';
import { StateCreator } from 'zustand';

import { Features, FeaturesPayload } from '../model/features';
import { IWorkspaceStore } from './workspace.store';

/**
 * This is just the state of the Features slice.
 */
export type FeaturesState = FeaturesPayload;

/**
 * Features-related actions.
 * If you want to add more, define them here.
 */
export interface FeaturesActions {
  isFeatureEnabled: (entity: keyof FeaturesState, feature: Features) => boolean;
  setFeatures: (features: Partial<FeaturesSlice>) => void;
}

export type FeaturesSlice = {
  features: FeaturesState & FeaturesActions;
};

/**
 * Creates the Features slice. This function can be merged into
 * a larger store (e.g. a workspace store).
 */
export const createFeaturesSlice: StateCreator<IWorkspaceStore, [], [], FeaturesSlice> = (
  set,
  get
) => ({
  features: {
    brand_assets: [],
    extended_editing: [],
    my_designs: [],
    sso: [],
    template_restrictions: [],
    uploader_config: [],
    users: [],
    white_label: [],

    isFeatureEnabled: (entity: keyof FeaturesState, feature: Features) => {
      const { company, features } = get();

      if (!company.isWorkspace) {
        return true;
      }

      if (!features[entity]) return false;

      return (features[entity] as Features[]).includes(feature);
    },

    setFeatures: (features: Partial<FeaturesSlice>) =>
      set(
        produce((draft: FeaturesSlice) => {
          draft.features = {
            ...draft.features,
            ...features,
          };
        })
      ),
  },
});
